'use client';
import { setVariantWithQuantity } from '@shared/components/cart/actions';
import { PageContainer } from '@shared/components/home/section';
import FullPageSpinner from '@shared/components/layout/spinner';
import { CHECKOUT_CART_COOKIE_NAME } from '@shared/lib/constants';
import { Product } from '@shared/lib/shopify/types';
import { Cart } from '@shared/lib/shopify/types/shopify-native';
import { groupLinesInCart } from '@shared/lib/utils/cart-utils';
import { useEffect, useState } from 'react';

export default function EmptyCartPrompt({
  isFirstTimeOrder,
  cart,
  kitProduct,
  quoteCart,
  children,
}: {
  isFirstTimeOrder: boolean;
  cart: Cart | undefined;
  quoteCart: Cart | undefined;
  kitProduct: Product;
  children: React.ReactNode;
}) {
  const { kit, inStockDiamonds, jewelry } = groupLinesInCart(cart);
  const [pendingKit, setPendingKit] = useState(false);
  useEffect(() => {
    const addKitToCart = async () => {
      try {
        if (
          isFirstTimeOrder &&
          !kit.length &&
          quoteCart &&
          !inStockDiamonds.length &&
          !jewelry.length
        ) {
          setPendingKit(true);
          const error = await setVariantWithQuantity(
            {
              cartId: cart?.id,
              cartCookieName: CHECKOUT_CART_COOKIE_NAME,
              variantId: kitProduct.variants[0]!.id,
              quantity: 1,
            },
            null
          );
          if (error) {
            console.error('Failed to add kit to cart:', error);
          }
          setPendingKit(false);
        }
      } catch (error) {
        console.error('Failed to add kit to cart:', error);
        setPendingKit(false);
      }
    };

    // Call the async function
    addKitToCart();
  }, [
    isFirstTimeOrder,
    cart,
    quoteCart,
    kitProduct,
    kit?.length,
    inStockDiamonds.length,
    jewelry.length,
  ]);

  if (pendingKit) {
    return (
      <PageContainer>
        <FullPageSpinner />
      </PageContainer>
    );
  }

  return <>{children}</>;
}
